import { Component, computed, inject } from '@angular/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { CommonModule } from '@angular/common';
import { LoaderService } from './loader.service';

@Component({
  selector: 'app-loader',
  standalone: true,
  imports: [MatProgressSpinnerModule, CommonModule],
  templateUrl: './loader.component.html',
  styleUrl: './loader.component.css'
})
export class LoaderComponent {
  loader = inject(LoaderService);
  showDialogLoader = computed(() => this.loader.dialogLoading());
  showGlobalLoader = computed(() => this.loader.loading() && !this.loader.dialogLoading());
}
